import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCategoryUnassignQuerySchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const CATEGORY_IDS_KEY = 'category_ids[]'

// DELETE reads category_ids from the query string; the server treats the key as optional.
const schema = MenuCategoryUnassignQuerySchema.extend({
  [CATEGORY_IDS_KEY]: z.array(z.int()).min(1).optional()
})

const normalize = fieldNormalizer({ intList: [CATEGORY_IDS_KEY] })

export const MenuCategoryUnassign = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema).superRefine((value, issues) => {
    const categoryIds = value[CATEGORY_IDS_KEY] ?? []
    categoryIds.forEach((id, index) => {
      if (categoryIds.indexOf(id) !== index) {
        issues.addIssue({
          code: 'custom',
          message: 'Duplicate categories are not allowed',
          path: [CATEGORY_IDS_KEY, index]
        })
      }
    })
  })
